import { PayoutHistoryPanel } from "@/components/organisms/Drivers/MyDrivers/ManageDriver/PayoutHistory/PayoutHistoryPanel";

export const PayoutHistory = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <PayoutHistoryPanel />
    </div>
  );
};
